import { KeyValuePair } from "@shoothill/core";
import { MentorAbsenceViewModel } from "../MentorAbsenceViewModel";

export class DomainManager {
    constructor(private viewModel: MentorAbsenceViewModel) {}

    public get mentorOptions(): KeyValuePair[] {
        return this.viewModel.model.mentors
            .map((m: any) => ({
                key: m.id,
                text: `${m.firstName} ${m.lastName}`,
            }))
            .sort((a, b) => a.text.localeCompare(b.text));
    }

    public get absenceShiftOptions(): KeyValuePair[] {
        return [
            { key: "1", text: "Morning" },
            { key: "2", text: "Afternoon" },
        ];
    }

    public get absenceTimeOptions(): KeyValuePair[] {
        return [
            { key: "1", text: "Lunch break " },
            { key: "2", text: "End of day" },
        ];
    }

    public get filteredAbsenceTimeOptions(): KeyValuePair[] {
        if (this.viewModel.getValue("absenceShift") === "2") {
            return [{ key: "2", text: "End of day" }];
        }
        return this.absenceTimeOptions;
    }
}
